import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import BikerRouter from "./components/pages/bikeRouter.component";
import BikerPhone from "./components/pages/bikerPhone.component";
import Feedni from "./components/pages/feedni.component";
const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/biker-web",
    element: <BikerRouter />,
  },
  {
    path: "/biker-phone",
    element: <BikerPhone />,
  },
  {
    path: "/feedni",
    element: <Feedni />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
